export const Z_BOTTOM = 0;
export const Z_BASE_TERRAIN = 1;
export const Z_BASE_WATER = 2;
export const Z_BASE_SATELLITE = 3;
export const Z_OVERLAY_TERRAIN = 10;
export const Z_OVERLAY_TRANSPORTATION = 12;
export const Z_OVERLAY_TEXT = 13;
export const Z_USER_DATA = 100;

// don't exceed 1000 without changing program.ts.
